import { Button } from "react-bootstrap";
import "./NavButton.css";

export const NavButton = ({ children, className = "", ...props }) => (
  <Button
    variant="outline-primary"
    className={`nav-btn ${className}`}
    {...props}
  >
    {children}
  </Button>
);
